
export default function getRatio(): number {
  return window.devicePixelRatio ? window.devicePixelRatio : 2;
}
